import script from "./industry-terminal-pay.vue?vue&type=script&lang=tsx&setup=true"
export * from "./industry-terminal-pay.vue?vue&type=script&lang=tsx&setup=true"

import "./industry-terminal-pay.vue?vue&type=style&index=0&id=9f2bc1ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f2bc1ae"]])

export default __exports__